export const SearchGenePropsOption = {
    mode: { type: String },
    trigger: { type: String },
    selector: { type: Array },
} as const;

export type SearchGeneProps = ExtractPropTypes<typeof SearchGenePropsOption>;

export const SearchGeneEmits = {
    change: (_data: any) => true,
    click: (_data: any) => true,
};
